import { render, staticRenderFns } from "./CederAsiento.vue?vue&type=template&id=5f240722"
import script from "./CederAsiento.vue?vue&type=script&setup=true&lang=js"
export * from "./CederAsiento.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports